import Tooltip from '@mui/material/Tooltip';
import type { FunctionComponent } from 'react';
import { useContext, useState } from 'react';

import { ApplicationContext } from '~/shared/context/context';
import type { LanguageCode } from '~/shared/internationalization';

import type { DecentSelectProps } from '../../design/components/form-fields/Select';
import { DecentSelect } from '../../design/components/form-fields/Select';
import { useSnackbars } from '../error-handling/SnackBars';

type LanguageSelectProps = {
    readonly disabled?: boolean;
    readonly fullWidth?: boolean;
    readonly isLabelVisible?: boolean;
    readonly isUnderlineDisabled?: boolean;
};

export const LanguageSelect: FunctionComponent<LanguageSelectProps> = (props) => {
    const { disabled, fullWidth, isLabelVisible, isUnderlineDisabled } = props;
    const { actions, applicationState, translate } = useContext(ApplicationContext);
    const { availableLanguages, languageKey } = applicationState;
    const [tooltipOpen, setTooltipOpen] = useState(false);
    const { showErrorSnackbar } = useSnackbars();

    const languageOptions: DecentSelectProps['options'] = Object.entries(availableLanguages).map(([key, lang]) => ({
        key,
        label: lang.name,
        value: lang.code,
    }));

    const code = languageOptions.find((option) => option.key === languageKey)?.value;

    return (
        <Tooltip
            open={disabled === true && tooltipOpen}
            placement="top-end"
            title={translate('dialogs.language-select-disabled-tooltip')}
        >
            <div>
                <DecentSelect
                    disabled={disabled}
                    isFullWidth={fullWidth ?? false}
                    isUnderlineDisabled={isUnderlineDisabled ?? false}
                    label={isLabelVisible === true ? translate('common.language') : undefined}
                    name="language-select"
                    options={languageOptions}
                    selectedValue={code}
                    onChange={(event) => {
                        try {
                            actions.setLanguage(event.target.value as LanguageCode);
                        } catch (error) {
                            showErrorSnackbar(error);
                        }
                    }}
                    onMouseLeave={() => setTooltipOpen(false)}
                    onMouseOver={() => setTooltipOpen(true)}
                />
            </div>
        </Tooltip>
    );
};
